import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Meter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m498.66 370-63.64 63.64 21.21 21.21 42.43-42.43c11.72-11.72 11.72-30.71 0-42.43z' />
    <path d='m660 481.17h-30c0-64.11-24.96-124.38-70.29-169.71s-105.6-70.29-169.71-70.29-124.38 24.96-169.71 70.29-70.29 105.6-70.29 169.71h-30c0-72.12 28.08-139.92 79.08-190.92s118.8-79.08 190.92-79.08 139.92 28.08 190.92 79.08 79.08 118.8 79.08 190.92z' />
    <path d='m660 570h-540v-88.83h30v58.83h480v-58.83h30z' />
    <path
      d='m315.97 477.03h163.87v30h-163.87z'
      transform='matrix(.70673644 -.70747692 .70747692 .70673644 -231.41 425.81)'
    />
    <path d='m270 480h-89.84s0-30 0-30h59.84c16.57 0 30 13.43 30 30z' />
    <path d='m375 360v-89.84s30 0 30 0v59.84c0 16.57-13.43 30-30 30z' />
    <path d='m510.16 480h89.84s0-30 0-30h-59.84c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Meter.displayName = 'Meter';

export default Meter;
